export default __webpack_public_path__ + "static/media/business.c8912208.png";